<template>
  <footer class="footer">
    <div class="container footer-inner">
      <div class="footer-brand">
        <RouterLink to="/" class="brand-name gradient-text">Vidya</RouterLink>
        <p>Building AI-driven fashion tech<br>with passion and precision.</p>
      </div>

      <div class="footer-nav">
        <span class="footer-nav-label">Navigate</span>
        <ul>
          <li><RouterLink to="/">Home</RouterLink></li>
          <li><RouterLink to="/about">About</RouterLink></li>
          <li><RouterLink to="/projects">Projects</RouterLink></li>
          <li><RouterLink to="/logo">The Logo</RouterLink></li>
        </ul>
      </div>

      <div class="footer-connect">
        <span class="footer-nav-label">Connect</span>
        <div class="social-row">
          <a
            href="https://linkedin.com/in/vidya-siva-80661?b8"
            target="_blank"
            rel="noopener"
            aria-label="LinkedIn"
            class="social-btn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            LinkedIn
          </a>
          <a
            href="mailto:vidya22061999@gmail.com"
            aria-label="Email"
            class="social-btn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            Email
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom container">
      <span>&copy; {{ currentYear }} Vidya Siva</span>
      <span class="footer-built">Built with Vue.js &amp; Firebase</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  border-top: 1px solid var(--border);
  padding: var(--space-16) 0 0;
  margin-top: auto;
}

.footer-inner {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: var(--space-12);
  padding-bottom: var(--space-12);
}

.brand-name {
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 700;
  display: block;
  margin-bottom: var(--space-3);
}

.footer-brand p {
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.footer-nav-label {
  display: block;
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-dim);
  margin-bottom: var(--space-4);
}

.footer-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.footer-nav a {
  font-size: 0.9rem;
  color: var(--text-muted);
  font-weight: 500;
  transition: color var(--transition-fast);
}

.footer-nav a:hover {
  color: var(--text);
}

.social-row {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.social-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-muted);
  transition: all var(--transition-fast);
  padding: 6px 0;
}

.social-btn:hover {
  color: var(--primary);
  transform: translateX(3px);
}

.footer-bottom {
  border-top: 1px solid var(--border);
  padding-top: var(--space-6);
  padding-bottom: var(--space-6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  color: var(--text-dim);
}

.footer-built {
  color: var(--text-dim);
}

@media (max-width: 768px) {
  .footer-inner {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-8);
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-bottom {
    flex-direction: column;
    gap: var(--space-2);
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-inner {
    grid-template-columns: 1fr;
  }
}
</style>
